/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Type_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Pick a conversation type" |
*
* @param {Manual_Meeting_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_type_placeholder = /** @type {((inputs?: Manual_Meeting_Type_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Type_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kies een gesprekstype")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un type d'entretien")
	return /** @type {LocalizedString} */ ("Pick a conversation type")
});